import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectorRef, Input, ViewChild, ElementRef } from '@angular/core';
import { AuftragEx, AuftragListItem } from 'src/app/api/model/model';
import { AuftragService } from 'src/app/api/auftrag.service';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { Subscription } from 'rxjs';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { MyApp } from 'src/app/api/helper/app';
import { Auftragsstatus } from 'src/app/api/model/aufteagsstatus';

import { AppConfig } from 'src/app/api/helper/app.config';
import { RemoteService } from 'src/app/api/remote.service';
import { Router } from '@angular/router';
import { Utils } from 'src/app/api/helper/utils';
import { Auftragdetails } from '../auftragdetails/auftragdetails.helper';
import { AuftragsKomponente, ReCoMobilLadeplanLaderaum } from 'src/app/api/model/swagger-model';

const log = new Logger("AuftragLkwLadeplanPage");

@Component({
    selector: 'auftrag-lkw-ladeplan',
    templateUrl: './auftrag-lkw-ladeplan.page.html',
    styleUrls: ['./auftrag-lkw-ladeplan.page.scss'],
    standalone: false
})
export class AuftragLkwLadeplanPage implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild('outerDiv', { static: true }) outerDiv: ElementRef;


    @Input() auftrag: AuftragEx;
    @Input() unterauftraege: AuftragListItem[];

    @Input() auftragdetails: Auftragdetails;
    @Input() komponente: AuftragsKomponente;

    laderaeume: LaderaumVO[] = [];
    subscriptions: Subscription[] = [];

    divWidth = 0;
    divHeight = 0;

    isDestroyed = false;

    constructor(
        private router: Router,
        private auftragService: AuftragService,
        private cdr: ChangeDetectorRef,
        private remoteService: RemoteService) { }

    async ngOnInit() {
        if (!this.auftrag?.Ladeplan?.Laderaeume) {
            return;
        }

        this.laderaeume = [];

        for (const laderaum of this.auftrag.Ladeplan.Laderaeume) {
            const vo: LaderaumVO = {
                label: laderaum.Label,
                laderaum: laderaum,
                paletten: []
            };

            if (!vo.label) {
                vo.label = laderaum.Nummer?.toString();
            }

            for (const packstueck of laderaum.Packstuecke) {
                const auftrag = this.unterauftraege.find(p => p.PaletteId === packstueck.Id);

                if (auftrag) {
                    vo.paletten.push({
                        left: '0px',
                        top: '0px',
                        width: '100px',
                        height: '100px',
                        color: auftrag.Zusatzdaten.Farbe,
                        auftrag: auftrag,
                        posL: Utils.parseFloat(auftrag.Zusatzdaten.PosL),
                        posB: Utils.parseFloat(auftrag.Zusatzdaten.PosB),
                        posH: Utils.parseFloat(auftrag.Zusatzdaten.PosH),
                        sizeL: Utils.parseFloat(auftrag.Zusatzdaten.SizeL),
                        sizeB: Utils.parseFloat(auftrag.Zusatzdaten.SizeB),
                        sizeH: Utils.parseFloat(auftrag.Zusatzdaten.SizeH),
                    });
                }
            }
            this.laderaeume.push(vo);
        }

        const intervalId = setInterval(() => {
            if (this.isDestroyed) {
                clearInterval(intervalId);
                return;
            }

            this.updatePaletten();
        }, 1000);

        this.updatePaletten();

        this.cdr.detectChanges();
    }

    updatePaletten() {
        const div = this.outerDiv?.nativeElement as HTMLDivElement;

        if (div) {
            this.divWidth = div.clientWidth;
            this.divHeight = div.clientHeight;
        }

        for (const vo of this.laderaeume) {
            if (this.divWidth) {
                const faktor = this.divWidth / vo.laderaum.Innenlaenge;
                vo.height = (faktor * vo.laderaum.Innenbreite) + 'px';
            }

            for (const palette of vo.paletten) {
                this.updatePalette(vo.laderaum, palette);
            }
        }

        this.cdr.detectChanges();
    }

    updatePalette(laderaum: ReCoMobilLadeplanLaderaum, palette: PaletteVO) {
        if (!this.divWidth) {
            return;
        }

        const faktorX = (this.divWidth / laderaum.Innenlaenge);

        palette.left = (faktorX * (laderaum.Innenlaenge - palette.posL - palette.sizeL)) + 'px';
        palette.top = (faktorX * palette.posB) + 'px';
        palette.width = (faktorX * palette.sizeL) + 'px';
        palette.height = (faktorX * palette.sizeB) + 'px';
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.updatePaletten();

            this.cdr.detectChanges();
        }, 50);
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
    }

    istAnderemGeraetZugeordnet(unterauftrag: AuftragListItem) {
        return unterauftrag.Auftragsstatus >= Auftragsstatus.Zugewiesen
            && unterauftrag.Geraet !== AppConfig.current.geraeteNummer;
    }

    async onUnterauftragClicked(unterauftrag: AuftragListItem) {
        log?.debug('onUnterauftragClicked', unterauftrag.Key);

        this.router.navigateByUrl('/auftragsliste/details/' + unterauftrag.Key);
    }
}

interface LaderaumVO {
    label: string;
    paletten: PaletteVO[];
    laderaum: ReCoMobilLadeplanLaderaum;
    height?: string;
}

interface PaletteVO {
    left: string;
    top: string;
    width: string;
    height: string;
    auftrag: AuftragListItem;
    color: string;

    posL: number;
    posB: number;
    posH: number;
    sizeL: number;
    sizeB: number;
    sizeH: number;
}